import styled from "styled-components";
import { Link } from "react-router-dom";

export const Container = styled.div`
  width: 100vw;
  min-height: 100vh;
  background: #ffffff;
  padding-left:250px;

`;

export const Content = styled.div`
  width: 90%;
  max-width: 1100px;

  margin: 6% auto;
`;

export const Title = styled.h1`
  width: 100%;
  margin: 0px 0px 15px 0px;
  padding: 0px;

  color: #000000;

  font-size: 28px;
  font-family: sans-serif;
  font-weight: 600;

  border-bottom: 1px solid rgba(34, 36, 38, 0.15);

  display: inline-block;
`;

export const Button = styled.button`
  font-size: 20px;
  margin-right: 0;
  cursor: pointer;
  font-weight: 400;
  padding: 4px 12px;
  border-radius: 4px;
  margin-top: 16px;
  float: left;
  border: none;
  cursor: pointer;
  z-index: 999;
  background: #dedede;
  transition: all 0.5s;

  :hover {
    background: #fefefe;
    transition: all 0.5s;
  }
`;

export const ContainerInputSearch = styled.div`
  width: 100%;
  height: 50px;

  & i {
    height: 75% !important;
  }
`;

export const Input = styled.input`
  width: 100%;
  height: 35px;
  margin: 0;
  padding: 0.67857143em 1em;
  outline: 0;
  background: #ffffff;
  color: rgba(0, 0, 0, 0.87);
  font-size: 13px;
  font-family: sans-serif;
  font-weight: 400;
  border: 1px solid rgba(34, 36, 38, 0.15);
  border-radius: 4px;
  box-shadow: 0 0 0 0 transparent inset;
  transition: color 0.1s ease, border-color 0.1s ease;
`;

export const CreateButton = styled(Link)`
  width: 100px;
  height: 35px;

  margin-left: 3px;

  color: #000000;
  background: #e0e1e2;

  border-radius: 5px;

  font-family: sans-serif;
  font-size: 16px;
  font-weight: 600;

  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: #cacbcd;
    font-weight: 700;
    color: #000000;
  }
`;

export const Image = styled.img`
  height: 5rem;
  width: auto;
`;

export const Label = styled.label`
  color: ${(props) => `${props.color}`};

  display: block;
  margin: 0 0 0.28571429rem;
  font-size: 0.92857143em;
  font-weight: 700;
  text-transform: none;
`;
export const Field = styled.div`
  width: ${(props) => props.width || "100%"};
  margin-top: 30px;
  display: block;

  & > div {
    margin-top: 10px;
  }
`;

export const Lista = styled.ul`
  display: flex;
  flex-direction: column;
  list-style: none;
  margin: auto;
  width: 100%;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

export const Opcoes = styled.li`
  padding: 12px 8px;
  width: 40%;
  font-size: 16px;
  color: #000;
  text-align: center;

  :hover {
    background: #dedede;
    cursor: pointer;
    transition: all 0.5s;
  }
`;

export const Pagination = styled.div`
  width: 200px;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  padding: 12px 8px;
  margin: 6px auto;

  & > span {
    font-size: 16px;
    font-weight: 400;
    margin: 6px 12px;
    cursor: pointer;
    padding: auto 16px;

    svg {
      font-size: 20px;
      margin-bottom: -4px;
    }
  }
`;

export const Table = styled.table`
  width: 100%;
  border: solid 1px #000;

  tr {
    padding: 4px;
    height: fit-content;

    :nth-child(odd) {
      background: #dedede;
    }

    :nth-child(even) {
      background: #fcfcfc;
    }
  }

  td {
    padding: 4px;

    svg {
      font-size: 16px;
      cursor: pointer;
    }
  }
`;

export const Back = styled.div`
  margin: 12px 4px;

  svg {
    font-size: 32px;
    cursor: pointer;
    transition: all 0.5s;

    :hover {
      transition: all 0.5s;
      transform: scale(1.15);
    }
  }
`;
